
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from '@mui/material';

interface ConfirmDialogProps {
    open: boolean;
    title?: string;
    message?: string;
    onCancel: () => void;
    onConfirm: () => void;
}

export const ConfirmDialog = ({
    open,
    title = "Are you sure?",
    message = "Please confirm your action.",
    onCancel,
    onConfirm,
}: ConfirmDialogProps) => {
    return (
        <Dialog open={open} onClose={onCancel}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <Typography>{message}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} style={{color:"black"}}>Cancel</Button>
                <Button onClick={onConfirm} style={{backgroundColor:"black"}} variant="contained">
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
};
